module.exports = [
    {
        path: '/inventory/utility/barcode',
        name: 'utility.barcode',
        component: require('../views/utility/barcode').vue
    }
]